import Vue from "vue";
import Vuex from "@src/_store/store";
import Routes from "@src/router";
import {requestStatus} from "@src/utils/checkRequestStatus";
import Cookies from "js-cookie";
import {Buffer} from "buffer";
import {queryFilter} from "@src/filters/query-filter";
import {globals} from "@src/utils/globals";

Vue.use(Cookies);
Vue.use(Vuex);

export const baseUrl = process.env.VUE_APP_API_URL;

export const urlApiVehicle = process.env.VUE_APP_API_DEV_VEHICLE_URL
    ? process.env.VUE_APP_API_DEV_VEHICLE_URL
    : baseUrl;

export const urlSMInternal = process.env.VUE_APP_API_DEV_SM
    ? process.env.VUE_APP_API_DEV_SM
    : baseUrl;

export const urlApiCatalogs = process.env.VUE_APP_API_DEV_CATALOGS
    ? process.env.VUE_APP_API_DEV_CATALOGS
    : baseUrl;

export function getHeaders(useVehicleToken = false, params = undefined) {
    const token = params && params.token ? params.token : Vuex.getters["auth/getState"].token;
    const lang = params && params.lang ? params.lang : Vuex.getters["auth/getState"].cultureName;
    const vehicleToken = !useVehicleToken ? null : Vuex.getters['vehicleIdentification/getState'].token;
    return {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Accept-Language": lang,
            ...(vehicleToken && { "Vehicle-Token": vehicleToken }),
        },
    };
}

export function getMultipartHeaders(useVehicleToken = false) {
    const vehicleToken = !useVehicleToken ? null : Vuex.getters['vehicleIdentification/getState'].token;
    return {
        headers: {
            "Authorization": `Bearer ${Vuex.getters["auth/getState"].token}`,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "multipart/form-data",
            "Accept-Language": Vuex.getters["auth/getState"].cultureName,
            ...(vehicleToken && { "Vehicle-Token": vehicleToken }),
        },
    };
}

export function getNoAuthHeaders(lang = undefined) {
    const language = lang ? lang : Vuex.getters["auth/getState"].cultureName;
    return {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Accept-Language": language,
        },
    };
}

export function getDeleteHeaders(data) {
    return {
        headers: {
            "Authorization": `Bearer ${Vuex.getters["auth/getState"].token}`,
            "Accept-Language": Vuex.getters["auth/getState"].cultureName,
            ...(data && { data }),
        },
    };
}

export function AuthServicesLoginInternal(email, password) {
    const urlApi = `${baseUrl}/Auth/login-internal`;

    const body = {
        email: email,
        password: password,
        domain: getDomain(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    return axios.post(
        urlApi,
        body,
        getNoAuthHeaders(Vuex.getters["domain/getStateDomainData"].cultureName)
    );
}

export function AuthServicesLoginSilent(token) {
    const query = queryFilter({
        token: token,
        domain: getDomain(),
    });
    const urlApi = `${baseUrl}/Auth/login-silent${query}`;

    return axios.get(urlApi, getHeaders());
}

function AuthServicesRefreshToken(token) {
    const urlApi = `${baseUrl}/Auth/refresh-token`;

    return axios.post(urlApi, { token });
}

export function AuthServicesRecoveryPassword(email) {
    const query = queryFilter({
        email: email,
        domain: getDomain(),
    });

    const urlApi = `${baseUrl}/User/recoverpassword${query}`;

    return axios.get(urlApi, getHeaders());
}

export function AuthServicesResetPassword(body, token) {
    const urlApi = `${baseUrl}/user/${token}/changepassword-from-recover`;

    return axios.put(urlApi, body, getHeaders());
}

function getLang() {
    if (navigator.languages != undefined) return navigator.languages[0];
    return navigator.language;
}

export function getDomain() {
    const domainEnv = process.env.VUE_APP_DOMAIN;

    if (domainEnv && domainEnv !== undefined) {
        return domainEnv;
    } else {
        const hostName = window.location.hostname;
        const parts = hostName.split(".");
        return parts[0];
    }
}

export function AuthServicesDomainValidation() {
    // if (localStorage.getItem("@datadrive:domain")) {
    //     const domain = JSON.parse(localStorage.getItem("@datadrive:domain"));

    //     return new Promise((resolve, reject) => {
    //         resolve({ data: { result: domain } });
    //     });
    // } else {
        const query = queryFilter({
            domain: getDomain(),
        });

        const urlApi = `${baseUrl}/Auth/domainvalidation${query}`;

        return axios.get(urlApi, getNoAuthHeaders(getLang()));
    //}
}

export async function AuthServicesGetUserDetails(
    cultureName,
    token = undefined
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Auth/login-internal-details`;

    return axios.get(
        urlApi,
        getHeaders(false, { lang: cultureName, token: token })
    );
}

export function isSignedIn(router) {
    const getToken = document.cookie.split("token=");
    let token = Cookies.get("token");

    if (!token) {
        const storageToken = Vuex.getters["auth/getState"].token;
        if (!storageToken) {
            token = getToken[1];
        } else {
            token = storageToken;
        }
    }

    if (!token) {
        localStorage.removeItem("@datadrive:initialState");
        Cookies.remove("token", { secure: true, expires: 1 });

        Vuex.commit("auth/setClearAuthStorage", {});

        return false;
    }

    try {
        const isTokenExpired = (token) =>
            Date.now() >=
            JSON.parse(Buffer.from(token.split(".")[1], "base64").toString())
                .exp * 1000;
        if (isTokenExpired(token)) {
            return AuthServicesRefreshToken(token)
                .then((response) => {
                    Vuex.commit("renderGetApi/setRender", true);

                    let payload = {
                        token: response.data.result,
                    };

                    let initialState = JSON.parse(
                        localStorage.getItem("@datadrive:initialState")
                    );

                    initialState = Object.assign(initialState, {
                        token: response.data.result,
                    });

                    Vuex.commit("auth/setState", initialState);

                    Cookies.set("token", response.data.result, {
                        secure: true,
                    });

                    Vuex.commit("auth/setTokenAndRefreshToken", payload);
                    return validPermissionDomain(router);
                })
                .catch((error) => {
                    Vuex.commit("renderGetApi/setRender", false);
                    localStorage.removeItem("@datadrive:initialState");
                    localStorage.removeItem("@datadrive:token");
                    Vuex.commit(
                        "vehicleIdentification/setVehicleIdentificationClear"
                    );
                    localStorage.removeItem("lastVehicle");
                    Cookies.remove("token", { secure: true, expires: 1 });
                    console.error(error);
                    if (router !== "login") {
                        const statusCode = 401;
                        const routName = "";
                        requestStatus.checkRequestStatus(statusCode, routName);
                    }
                    return false;
                });
        } else {
            Vuex.commit("renderGetApi/setRender", true);

            let initialState = JSON.parse(
                localStorage.getItem("@datadrive:initialState")
            );
            if (initialState) {
                const href = window.location.href;
                if (!initialState.acceptedTerms && !href.includes("terms-and-conditions")) {
                    return Routes.push("/terms-and-conditions");
                }
                return validPermissionDomain(router);
            }
            return false;
        }
    } catch (error) {
        console.log(error);
        return false;
    }
}

function validPermissionDomain(r) {
    const IdsModules = [
        { name: "budget", id: 2, type: 1 },
        { name: "budget_nextRevision", id: 9, type: 2 },
        { name: "budget_tyres", id: 9, type: 2 },
        { name: "budget_repair-service", id: 10, type: 2 },
        { name: "budget_repair_graphic", id: 9, type: 2 },
        { name: "budget_test_graphic", id: 9, type: 2 },

        { name: "technicalInformation", id: 4, type: 1 },
        { name: "maintenance-plan", id: 4, type: 1 },
        { name: "tech-manuals", id: 4, type: 1 },
        { name: "tech-data", id: 4, type: 1 },
        { name: "repair-times", id: 4, type: 1 },
        { name: "tech-info-manual", id: 4, type: 1 },
        { name: "categories-tech-manuals", id: 4, type: 1 },
        { name: "mygarage", id: 4, type: 1 },

        { name: "marketing", id: 17, type: 1 },

        { name: "environmentalManagement", id: 8, type: 1 },

        { name: "active-reception", id: 6, type: 1 },

        { name: "vehicleIdentification", id: 1, type: 1 },

        { name: "planning", id: 15, type: 1 },
        { name: "create-planning", id: 15, type: 1 },
        { name: "edit-planning", id: 15, type: 1 },

        { name: "user-config", id: "config-user", type: "config-user" },
    ];

    const user = JSON.parse(localStorage.getItem("@datadrive:initialState"));

    if (r == undefined) {
        return true;
    }

    if (r == "login") {
        return true;
    }

    //BACKOFFICE Role id 1 and 2
    if (r == "backoffice") {
        if (
            user.roleId == globals.ROLES.ADMIN ||
            user.roleId == globals.ROLES.ACCOUNT_MANAGER
        ) {
            return true;
        }
    }

    const id = IdsModules.filter((el) => el.name == r)[0].id;
    const type = IdsModules.filter((el) => el.name == r)[0].type;

    return foreachModulesAndSubModules(id, type);
}

function foreachModulesAndSubModules(idModule, type) {
    const user = JSON.parse(localStorage.getItem("@datadrive:initialState"));
    let state = false;

    user.modules.forEach((el) => {
        if (type == 1) {
            if (el.moduleId == idModule) {
                state = true;
            }
        } else if (type == 2) {
            if (el.subModules) {
                el.subModules.forEach((elSub) => {
                    if (elSub.subModuleId == idModule) {
                        state = true;
                    }
                });
            }
        } else {
            if (el.underSubModules) {
                el.underSubModules.forEach((elSub) => {
                    if (elSub.underSubModuleId == idModule) {
                        state = true;
                    }
                });
            }
        }

        if (idModule == "config-user" && type == "config-user") {
            state = true;
        }
    });

    return state;
}
